export default "__VITE_ASSET__BR82uGSt__"